import styled from 'styled-components';

export const StyledIconContainer = styled.div`
    ${() => `
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;

    border-radius: 50%;

 
    `}
`;

export const StyledControllerContainer = styled.div`
    ${() => `
    position: absolute;
    left: 0;
    right: 0;
    bottom: 7px;

    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 5;

    opacity: 0;
    transition: opacity .2s ease-out;

    &:hover {
        opacity: 1;
    }
    `}
`;
